export default "__VITE_ASSET__WlS43GxL__"